import Controller from "./editableImageUploader.controller";
import template from "./editableImageUploader.html";

const editableImageUploader = {
  template,
  controller: Controller,
  bindings: {
    documents: "<",
    documentsMetadata: "<",
    maxFiles: "<",
    maxSize: "<",

    resource: "@",
    uploadMethod: "@",
    updateMethod: "@",
    resourceId: "<",
  },
};

export default editableImageUploader;



// WEBPACK FOOTER //
// ./src/components/editableImageUploader/editableImageUploader.component.js